import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetGrpoData } from '../../../APIServices/ProductionService/GRPOServices/grpoThunk';
import { convertCase } from '../../../SharedFiles/Helper/utils';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

const GRPOSearch = ({
  inputFields,  // An array of field names (['poDocNum', 'vehicleNumber'])
  values,       // Object containing the current values for each field
  // handleChange, 
  filteredResults,
  handleSelectSuggestion,
  dropdownVisibility,
  handleInputChange,
  setDropdownVisibility,
  setActiveField,
  activeField
}) => {

  const dropdownRef = useRef(null);
  const { t } = useTranslation();

  // Close the dropdown if user clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // Close the dropdown if click is outside
        setDropdownVisibility((prev) => ({
          ...prev,
          [activeField]: false, // Hide the dropdown for the active field
        }));
      }
    };

    // Add the event listener when the dropdown is visible
    if (dropdownVisibility[activeField]) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownVisibility, activeField, setDropdownVisibility]);


  const handleItemClick = (item, fieldName) => {
    if(item.remaining_Coils<=0){
      toast.error("Number of coils for PO is Completed");
    }else{
      handleSelectSuggestion(item, fieldName); // Pass the full item and field name
      setDropdownVisibility((prev) => ({
        ...prev,
        [fieldName]: false  // Show dropdown for the corresponding field
      }));
    }
    
  };
  
  const handleActiveField = (header) => {
    setActiveField(header);  
    setDropdownVisibility((prev) => ({
      ...prev,
      [header]: true, // Hide the dropdown for the active field
    }));
           
};
  return (
    <div className="row">
      {/* Render each input field dynamically based on inputFields array */}
      {inputFields.map((field, index) => (
       
        <div key={index} className="col-6 mb-1 position-relative">
          {field !== "no_Of_Coils" && ( <>
            <label htmlFor={field} className="custom-label">{t(convertCase(field))}</label>
        
          <input
            type="text"
            id={field}
            className="form-control custom-input"
            placeholder={t(field)}
            autoComplete="off"
            onClick={() => handleActiveField(field)}
            value={values[field]}  // Use the value passed from the parent component
            onChange={(e) => handleInputChange(e, field)}  // Handle change dynamically
            style={{ outline: "none", boxShadow: "none" }}
            /> </>)}
          
          

          {/* Dropdown for suggestions */}
          {dropdownVisibility[field] &&  (
            <ul
            ref={dropdownRef}
             className="list-group position-absolute" 
             style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 10 }}>
              {filteredResults.map((item, index) => (
                <li
                  key={index}
                  className="list-group-item list-group-item-action"
                  onClick={() => handleItemClick(item, field)}
                  style={{ cursor: 'pointer' }}
                >
                  {field === 'po_Doc_Num' ? item.po_Doc_Num : item.vehicle_Number} /
                  {field === 'po_Doc_Num' ? item.vehicle_Number : item.po_Doc_Num}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default GRPOSearch;
